// User
import {
  USER_FORM_CLEAR,
  USER_FORM_FETCH_REQUEST,
  USER_FORM_FETCH_RESPONSE_ERROR,
  USER_FORM_FETCH_RESPONSE_SUCCESS,
  USER_FORM_INIT_REQUEST,
  USER_FORM_INIT_RESPONSE_ERROR,
  USER_FORM_INIT_RESPONSE_SUCCESS,
  USER_FORM_SUBMIT_REQUEST,
  USER_FORM_SUBMIT_RESPONSE_ERROR,
  USER_FORM_SUBMIT_RESPONSE_SUCCESS,
  USER_GRID_CHANGE_FILTER,
  USER_GRID_CHANGE_PAGINATION,
  USER_GRID_CHANGE_SORT,
  USER_GRID_DELETE_REQUEST,
  USER_GRID_DELETE_RESPONSE_ERROR,
  USER_GRID_DELETE_RESPONSE_SUCCESS,
  USER_GRID_FETCH_REQUEST,
  USER_GRID_FETCH_RESPONSE_ERROR,
  USER_GRID_FETCH_RESPONSE_SUCCESS,
} from "../constants/actionTypes";

const initialState = {
  formData: {},
  formDataOrganizations: [],
  formDataRoles: [],
  formErrors: [],
  formIsFetching: false,
  formIsInitializing: false,
  formIsSubmitting: false,
  gridData: [],
  gridDataTotal: 0,
  gridIsDeleting: false,
  gridErrors: [],
  gridIsFetching: false,
  gridFilters: [],
  gridPage: 1,
  gridPageSize: 10,
  gridSortField: "email",
  gridSortOrder: "asc",
};

const user = (state = initialState, action) => {
  switch (action.type) {
    // FORM - Clear
    case USER_FORM_CLEAR:
      return {
        ...state,
        formData: {},
        formDataOrganizations: [],
        formDataRoles: [],
        formErrors: [],
        formIsFetching: false,
        formIsInitializing: false,
        formIsSubmitting: false,
      };

    // FORM - Fetch
    case USER_FORM_FETCH_REQUEST:
      return {
        ...state,
        formData: {},
        formErrors: [],
        formIsFetching: true,
      };
    case USER_FORM_FETCH_RESPONSE_ERROR:
      return {
        ...state,
        formErrors: action.payload,
        formIsFetching: false,
      };
    case USER_FORM_FETCH_RESPONSE_SUCCESS:
      return {
        ...state,
        formData: action.payload,
        formIsFetching: false,
      };

    // FORM - Init
    case USER_FORM_INIT_REQUEST:
      return {
        ...state,
        formIsInitializing: true,
      };
    case USER_FORM_INIT_RESPONSE_ERROR:
      return {
        ...state,
        formDataOrganizations: [],
        formDataRoles: [],
        formIsInitializing: false,
      };
    case USER_FORM_INIT_RESPONSE_SUCCESS:
      return {
        ...state,
        formDataOrganizations: action.payload.organizations,
        formDataRoles: action.payload.roles,
        formIsInitializing: false,
      };

    // FORM - Submit
    case USER_FORM_SUBMIT_REQUEST:
      return {
        ...state,
        formIsSubmitting: true,
      };
    case USER_FORM_SUBMIT_RESPONSE_ERROR:
      return {
        ...state,
        formErrors: action.payload,
        formIsSubmitting: false,
      };
    case USER_FORM_SUBMIT_RESPONSE_SUCCESS:
      return {
        ...state,
        formErrors: [],
        formIsSubmitting: false,
      };

    // GRID - Change - Filter
    case USER_GRID_CHANGE_FILTER:
      return {
        ...state,
        gridFilters: action.payload.filters,
      };

    // GRID - Change - Pagination
    case USER_GRID_CHANGE_PAGINATION:
      return {
        ...state,
        gridPage: action.payload.page,
        gridPageSize: action.payload.pageSize,
      };

    // GRID - Change - Sort
    case USER_GRID_CHANGE_SORT:
      return {
        ...state,
        gridSortField: action.payload.sortField,
        gridSortOrder: action.payload.sortOrder,
      };

    // GRID - Delete
    case USER_GRID_DELETE_REQUEST:
      return {
        ...state,
        gridIsDeleting: true,
      };
    case USER_GRID_DELETE_RESPONSE_ERROR:
      return {
        ...state,
        gridData: [],
        gridDataTotal: 0,
        gridIsDeleting: false,
        gridErrors: action.payload,
      };
    case USER_GRID_DELETE_RESPONSE_SUCCESS:
      return {
        ...state,
        gridIsDeleting: false,
        gridErrors: [],
      };

    // GRID - Fetch
    case USER_GRID_FETCH_REQUEST:
      return {
        ...state,
        gridIsFetching: true,
      };
    case USER_GRID_FETCH_RESPONSE_ERROR:
      return {
        ...state,
        gridData: [],
        gridDataTotal: 0,
        gridErrors: action.payload,
        gridIsFetching: false,
      };
    case USER_GRID_FETCH_RESPONSE_SUCCESS:
      return {
        ...state,
        gridData: action.payload.data,
        gridDataTotal: action.payload.total,
        gridErrors: [],
        gridIsFetching: false,
      };
    default:
      return state;
  }
};

export default user;
